var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.797 5.542l-2.401 1.224-11.598 5.907a6.909 6.909 0 0110.219-6.925l1.374-.7.206-.105a8.439 8.439 0 00-13.372 7.473 1.535 1.535 0 01-.834 1.483l-.724.37v1.724L4.8 14.905l.69-.352.682-.347 12.226-6.23 1.374-.7 2.84-1.447V4.106l-2.816 1.436zM22.613 7.555L6.867 15.572l-1.373.7-2.827 1.441v1.723l2.807-1.43 2.402-1.224 11.61-5.916a6.909 6.909 0 01-10.229 6.93l-.085.045-1.49.76a8.439 8.439 0 0013.372-7.475 1.536 1.536 0 01.833-1.484l.726-.37V7.556z",
    fill: "#000"
  })));
}
export default SvgXlmLogo;